<template>
  <div class="empty-table">
    <img src="@/assets/images/bulk-empty@2x.png" class="empty-table-img" />
    <p class="empty-table-title">Henüz şablon indirmediniz.</p>
    <p class="empty-table-text">Şablon indirdiğinizde bu ekranda görebilirsiniz.</p>
  </div>
</template>
<script setup>
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.empty-table {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: $colorN80;
  padding: 64px;

  &-img {
    width: 120px;
    height: 120px;
    margin-bottom: 24px;
  }

  &-title {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 12px;
  }

  &-text {
    font-size: 16px;
    font-weight: 600;
  }
}
</style>